export enum QuoteStatus {

    Tradable = 1,
    Indicative = 2,
    Stale = 3,
    Spike = 4,
    CloseOnly = 5
}
